export default __webpack_public_path__ + "static/media/plastic.ce5ea94f.png";